module.exports = __webpack_public_path__ + "img/1493753339.aca2ca37.jpg";